export default __webpack_public_path__ + "static/media/logoWhite.1fd026ea.svg";